import { siteConfig } from "@/components/seoConfig";
import { GOOGLE_PROFILE_URL } from "@/components/googleReviewsData";

export default function JsonLd({
  description,
  isPartOf,
  title,
  canonical,
  OgImageUrl,
  BreadcrumbListJson,
  FAQ,
  datePublished,
  // ביקורות מוצגות רק בדף שבו הן באמת מופיעות למשתמש (דף הבית).
  // הזרקה שלהן לכל דף — כולל תקנון ופרטיות — מנוגדת להנחיות הנתונים המובנים.
  withReviews = false,
}) {
  const today = new Date().toISOString().split("T")[0];
  const categoryPageJsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      ...(FAQ ? [FAQ] : []),
      // SoftwareApplication
      {
        "@type": "SoftwareApplication",
        "@id": "https://quicktor.co.il/#software",
        "name": siteConfig.siteName,
        "alternateName": "QuickTor",
        "url": "https://quicktor.co.il/",
        "description": "מערכת ישראלית לניהול תורים לקוסמטיקאיות, נייליסטיות ומכוני יופי: דף עסק לקביעת תורים 24/7, תזכורות וואטסאפ אוטומטיות עם אישור הגעה, מקדמות ותשלומים, הצהרות בריאות עם חתימה דיגיטלית, תיק לקוחה, סדרות טיפולים, מלאי וחובות לקוחות.",
        "inLanguage": "he-IL",
        "publisher": { "@id": "https://quicktor.co.il/#organization" },
        "downloadUrl": "https://play.google.com/store/apps/details?id=com.eeefg.QuickTor",
        "featureList": [
          "קביעת תורים אונליין 24/7 מדף עסק אישי",
          "תזכורות וואטסאפ אוטומטיות ואישור הגעה",
          "גביית מקדמה או תשלום מלא בקביעת התור",
          "הצהרות בריאות עם חתימה דיגיטלית",
          "תיק לקוחה עם היסטוריה ותמונות לפני ואחרי",
          "ניהול סדרות טיפולים",
          "ניהול מלאי עם התראות",
          "ניהול חובות של לקוחות",
          "ניהול עובדות עם יומנים נפרדים",
          "רשימת המתנה",
        ],
        "audience": { "@type": "BusinessAudience", "audienceType": "קוסמטיקאיות, נייליסטיות ומכוני יופי בישראל" },
        "operatingSystem": siteConfig.software.operatingSystem,
        "applicationCategory": siteConfig.software.applicationCategory,
        "offers": {
          "@type": "Offer",
          "price": siteConfig.software.price,
          "priceCurrency": siteConfig.software.currency,
          "description": "מנוי חודשי, לא כולל מע״מ, כל הפיצ'רים כלולים, 14 ימי ניסיון",
        },
        ...(withReviews
          ? {
              "review": [
                {
                  "@type": "Review",
                  "author": { "@type": "Person", "name": "אלנה" },
                  "datePublished": "2026-05-10",
                  "reviewBody": "חסכתי 3 שעות בשבוע — בלי לעשות כלום",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5" }
                },
                {
                  "@type": "Review",
                  "author": { "@type": "Person", "name": "אתי" },
                  "datePublished": "2026-05-15",
                  "reviewBody": "הלקוחות מבטלות פחות — הכסף נשאר בחשבון",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5" }
                }
              ]
            }
          : {})
      },
      // website
      {
        "@type": "WebSite",
        "@id": "https://quicktor.co.il/#website",
        url: "https://quicktor.co.il/",
        name: "QuickTor",
        description:
          "QuickTor - נהלו תורים בקלות עם מערכת חכמה הכוללת הודעות וואטסאפ, תשלום מראש על תור וזימון תורים אונליין. פתרון All-in-One לניהול העסק שלך. התחל עכשיו!",
        // אין חיפוש פנימי באתר — SearchAction הוסר כדי לא להצהיר על יכולת שאינה קיימת.
        inLanguage: "he-IL",
      },
      // webpage
      {
        "@type": "WebPage",
        "@id": canonical,
        url: canonical,
        name: title,
        isPartOf: {
          "@id": "https://quicktor.co.il/#website",
        },
        primaryImageOfPage: {
          "@id": OgImageUrl,
        },
        image: {
          "@id": OgImageUrl,
        },
        thumbnailUrl: OgImageUrl,
        description: description,
        breadcrumb: {
          "@id": `${canonical}#breadcrumb`,
        },
        inLanguage: "he-IL",
        datePublished: datePublished || "2026-02-01",
        dateModified: today,
        // GEO: speakable — מאפשר ל-AI לזהות קטעי טקסט מרכזיים
        speakable: {
          "@type": "SpeakableSpecification",
          cssSelector: ["h1", "h2", ".hero-description", ".faq-answer"],
        },
        // GEO: about — הנושא המרכזי של הדף
        about: {
          "@type": "Thing",
          name: "ניהול תורים לעסקים בישראל",
          description: "מערכת חכמה לניהול תורים, לקוחות ותשלומים לעסקים קטנים ובינוניים בישראל",
          sameAs: "https://en.wikipedia.org/wiki/Appointment_scheduling_software",
        },
        // GEO: mentions — ישויות הנזכרות בדף
        mentions: [
          { "@type": "Thing", name: "ניהול תורים אונליין" },
          { "@type": "Thing", name: "תזכורות WhatsApp" },
          { "@type": "Thing", name: "גביית תשלום מראש" },
          { "@type": "Thing", name: "זימון תורים" },
          { "@type": "Organization", name: "QuickTor", url: "https://quicktor.co.il" },
          { "@type": "Place", name: "ישראל", sameAs: "https://www.wikidata.org/wiki/Q801" },
        ],
        potentialAction: [
          {
            "@type": "ReadAction",
            target: [canonical],
          },
        ],
      },
      // ImageObject
      {
        "@type": "ImageObject",
        inLanguage: "he-IL",
        "@id": OgImageUrl,
        url: OgImageUrl,
        contentUrl: OgImageUrl,
        width: 1200,
        height: 630,
      },
      // LocalBusiness & ProfessionalService
      {
        "@type": ["LocalBusiness", "ProfessionalService"],
        "@id": "https://quicktor.co.il/#localbusiness",
        "name": "QuickTor",
        "alternateName": "QuickTor מערכת לניהול תורים",
        "image": "https://quicktor.co.il/sectionmainpage.webp", // כתובת מלאה
        "telephone": "+972557259188",
        "email": "mail@quicktor.co.il",
        "url": "https://quicktor.co.il/",
        "priceRange": "₪₪", // מומלץ להשתמש בסימנים $ או ₪ (1-4 סימנים) או טווח מחירים
        "areaServed": {
          "@type": "Country",
          "name": "Israel",
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "יגאל אלון 94",
          "addressLocality": "תל אביב",
          "postalCode": "6789139",
          "addressCountry": "IL"
        },
        "hasMap": GOOGLE_PROFILE_URL,
        "sameAs": [
          "https://www.instagram.com/quick_tor",
          "https://www.facebook.com/profile.php?id=61558413038387",
          "https://play.google.com/store/apps/details?id=com.eeefg.QuickTor",
          "https://apps.apple.com/be/app/quicktor/id6476108765",
          GOOGLE_PROFILE_URL
        ],
      },
      // Organization
      {
        "@type": "Organization",
        "@id": "https://quicktor.co.il/#organization",
        "name": "QuickTor",
        "url": "https://quicktor.co.il/",
        "logo": {
          "@type": "ImageObject",
          "inLanguage": "he-IL",
          "@id": "https://quicktor.co.il/testlogo.png", // כתובת מלאה
          "url": "https://quicktor.co.il/testlogo.png",
          "contentUrl": "https://quicktor.co.il/testlogo.png",
          "width": 1408,
          "height": 736,
          "caption": "QuickTor מערכת לניהול תורים",
        },
        "sameAs": [
          GOOGLE_PROFILE_URL,
          "https://www.instagram.com/quick_tor",
          "https://www.facebook.com/profile.php?id=61558413038387",
          "https://play.google.com/store/apps/details?id=com.eeefg.QuickTor",
          "https://apps.apple.com/be/app/quicktor/id6476108765",
        ],
        "founder": { "@id": "https://quicktor.co.il/about#founder" },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+972557259188",
          "contactType": "customer service",
          "email": "mail@quicktor.co.il"
        }
      },
      // Founder
      {
        "@type": "Person",
        "@id": "https://quicktor.co.il/about#founder",
        "name": "Din Roda",
        "alternateName": "דין",
        "jobTitle": "מייסד ומפתח QuickTor",
        "url": "https://quicktor.co.il/about",
        "worksFor": { "@id": "https://quicktor.co.il/#organization" },
      },
      // BreadcrumbList
      {
        "@type": "BreadcrumbList",
        description: "Breadcrumbs list",
        "@id": `${canonical}#breadcrumb`,
        itemListElement: BreadcrumbListJson,
      },
    ].filter(Boolean),
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(categoryPageJsonLd) }}
    />
  );
}
